import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { Options } from 'models';

import { classNames } from 'uitk-react-utils';

import {
  StrikeoutPriceAndInfoContainer,
  StrikeoutPriceAndInfoContainerProps
} from 'components/common/pricing/strikeout-price-and-info-container';

export interface LeadAndSubPriceProps {
  option: Options;
  strikeoutDisclaimer?: string;
  query?: any;
  dialogId?: string;
  handleClose?: () => void;
  wrapPrice?: boolean;
  dialogType?: string;
  priceFontWeight?: string;
  viewed?: boolean;
  label?: string;
}

export const LeadAndSubPrice: React.FunctionComponent<LeadAndSubPriceProps> = ({
  label,
  option,
  priceFontWeight,
  viewed,
  strikeoutDisclaimer,
  query,
  dialogId,
  handleClose,
  wrapPrice,
  dialogType
}) => {
  if (!option) {
    return null;
  }
  const { displayPrice, loyaltyPrice, leadingCaption } = option;
  const price =
    (displayPrice && displayPrice.formatted) ||
    (loyaltyPrice &&
      loyaltyPrice.amount &&
      loyaltyPrice.amount.formatted &&
      loyaltyPrice.unit &&
      `${loyaltyPrice.amount.formatted} ${loyaltyPrice.unit}`) ||
    null;
  const strikeOut = option.strikeOut && option.strikeOut.formatted;
  const strikeoutInfo: StrikeoutPriceAndInfoContainerProps = {
    ...{
      strikeoutDisclaimer,
      strikeOut,
      query,
      dialogId,
      handleClose,
      wrapPrice,
      dialogType
    }
  };
  const priceType = leadingCaption ? `secondary` : `lead`;

  if (!price) {
    return strikeOut ? <StrikeoutPriceAndInfoContainer {...strikeoutInfo} /> : null;
  }
  const classes = leadingCaption
    ? classNames(`uitk-cell uitk-type-300`, {
        ['m-cell-shrink l-cell-shrink xl-cell-shrink']: wrapPrice,
        ['pwa-theme--grey-700']: viewed
      })
    : classNames(`uitk-cell uitk-type-${priceFontWeight} uitk-type-bold`, {
        ['all-cell-shrink']: !wrapPrice,
        ['m-cell-shrink l-cell-shrink xl-cell-shrink']: wrapPrice,
        ['pwa-theme--grey-700']: viewed
      });

  return (
    <>
      {strikeOut && <StrikeoutPriceAndInfoContainer {...strikeoutInfo} />}
      <span className={`${classes}`} data-stid="content-hotel-display-price">
        <span className="is-visually-hidden">
          <LocalizedText
            message={strikeOut ? 'hotels.infosite.rateInfoDialog.leadWithStrikeOutPresent' : 'hotels.infosite.rateInfoDialog.lead'}
            data={[price]}
          />
        </span>
        {leadingCaption && `${leadingCaption} `}
        <span className={`${classes}`} data-stid={`content-hotel-${priceType}-price`} aria-hidden="true">
          {price}
        </span>
        {label && (
          <span className="uitk-type-400 uitk-type-regular pwa-theme--grey-900" data-stid="lead-price--text">
            {label}
          </span>
        )}
      </span>
    </>
  );
};
